module.exports = __webpack_public_path__ + "img/fan.52bdfe0e.png";